import { createLocalStorageStateHook } from "use-local-storage-state";

const useAdminToken = createLocalStorageStateHook<string | null>(
  "admin-token",
  null
);

export default useAdminToken;
